var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.048,
    height: 33,
    viewBox: "0 0 32.048 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Direct_Donation",
    "data-name": "Direct Donation",
    transform: "translate(-310.5 -1011.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    transform: "translate(322.089 1022.367)",
    fill: "#fff",
    stroke: "#b07f4a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.544,
    cy: 5.544,
    r: 5.544,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.544,
    cy: 5.544,
    r: 4.544,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    transform: "translate(319.132 1024.585)",
    fill: "#fff",
    stroke: "#b07f4a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.544,
    cy: 5.544,
    r: 5.544,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.544,
    cy: 5.544,
    r: 4.544,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M23.678,22.068a1.726,1.726,0,0,0-.261.022h0v0a1.786,1.786,0,0,0-.671.253l-4.95,3.086A1.831,1.831,0,0,0,17.128,24a2.578,2.578,0,0,0-1.577-.44H13.42a4.661,4.661,0,0,1-1.459-.483,5.24,5.24,0,0,0-1.713-.591H7.027a4.514,4.514,0,0,0-2.011.581,4.385,4.385,0,0,1-1.182.494H2V24.3H3.833a3.476,3.476,0,0,0,1.513-.573,3.836,3.836,0,0,1,1.682-.5h3.176a5.747,5.747,0,0,1,1.448.524,4.51,4.51,0,0,0,1.765.55H15.55a1.91,1.91,0,0,1,1.132.291,1.038,1.038,0,0,1,.393.931,1.229,1.229,0,0,1-.237.744,1.565,1.565,0,0,1-.142.183,1.605,1.605,0,0,1-1.147.335H11.289v.739H15.55a2.247,2.247,0,0,0,2.133-1.155l5.453-3.4a1.036,1.036,0,0,1,1.453.35l.166.268a1.107,1.107,0,0,1-.345,1.508h0l-5.892,3.692c-.009.007-.067.018-.2.068l-.011.007-.01.007a1.069,1.069,0,0,1-.414.068H2v.739H17.88a1.727,1.727,0,0,0,.715-.133h0a.99.99,0,0,0,.31-.126L24.8,25.721h0a1.848,1.848,0,0,0,.584-2.521l-.166-.269h0a1.8,1.8,0,0,0-1.541-.863Z",
    transform: "translate(309 1014.395)",
    fill: "#b07f4a",
    stroke: "#b07f4a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M3.977,29.673a1.726,1.726,0,0,0,.261-.022h0v0a1.786,1.786,0,0,0,.671-.253l4.95-3.086a1.831,1.831,0,0,0,.667,1.427,2.578,2.578,0,0,0,1.577.44h2.131a4.661,4.661,0,0,1,1.459.483,5.24,5.24,0,0,0,1.713.591h3.221a4.514,4.514,0,0,0,2.011-.581,4.385,4.385,0,0,1,1.182-.494h1.834v-.739H23.822a3.476,3.476,0,0,0-1.513.573,3.836,3.836,0,0,1-1.682.5H17.45A5.746,5.746,0,0,1,16,27.994a4.51,4.51,0,0,0-1.765-.55H12.1a1.91,1.91,0,0,1-1.132-.291,1.038,1.038,0,0,1-.393-.931,1.229,1.229,0,0,1,.237-.744,1.565,1.565,0,0,1,.142-.183,1.605,1.605,0,0,1,1.147-.335h4.261V24.22H12.1a2.247,2.247,0,0,0-2.133,1.155l-5.453,3.4a1.036,1.036,0,0,1-1.453-.35L2.9,28.159a1.107,1.107,0,0,1,.345-1.508h0l5.892-3.692c.009-.007.067-.018.2-.068l.011-.007.01-.007a1.069,1.069,0,0,1,.414-.068H25.655v-.739H9.775a1.727,1.727,0,0,0-.715.133h0a.99.99,0,0,0-.31.126L2.856,26.02h0a1.848,1.848,0,0,0-.584,2.521l.166.269h0a1.8,1.8,0,0,0,1.541.863Z",
    transform: "translate(316.392 990)",
    fill: "#b07f4a",
    stroke: "#b07f4a",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation1);
export default __webpack_public_path__ + "static/media/donation1.b0043c2c1aad51cc76656b2c1772f4b8.svg";
export { ForwardRef as ReactComponent };